import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApplicationOwnerItem } from './application.owner.item';
import { ApplicationBusinessInfo } from './application.business.info';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { FormBuilder } from '@angular/forms';
import { ApplicationACHInfo } from './application.ach.info';
import { ApplicationEquipmentItem } from './application.equipment.item';
import { ApplicationEquipmentDescription } from './application.equipment.description';
import { ApplicationSoleOwnerItem } from './application.sole.owner.item';
import { GoogleAnalyticsService } from 'src/app/analytics/google.analytics.service';
declare var $: any;

@Component({
    selector: 'app-application',
    templateUrl: './application.component.html',
    styleUrls: ['./application.component.css']
})
export class ApplicationComponent implements OnInit {

    step = 1;
    token: any;
    dbaName: any = '';
    referralPage: any;
    tokenVendorId: any;
    googleVariant: any;
    googleExperience: any;
    applicationId: number;
    industries: any[] = [];
    equipmentSetup: any = {};
    businessTypes: any[] = [];
    businessSubmitted: any = false;
    offers: any = { offerList: [] };
    statesOfIncorporation: any[] = [];
    achInfo: ApplicationACHInfo = new ApplicationACHInfo(this.formBuilder);
    owners: ApplicationOwnerItem[] = [new ApplicationOwnerItem(this.formBuilder)];
    sOwner: ApplicationSoleOwnerItem = new ApplicationSoleOwnerItem(this.formBuilder, this.authService);
    equipmentItems: ApplicationEquipmentItem[] = [new ApplicationEquipmentItem(this.formBuilder)];
    appInfo: ApplicationBusinessInfo = new ApplicationBusinessInfo(this.formBuilder, this.authService);
    equipmentDescription: ApplicationEquipmentDescription = new ApplicationEquipmentDescription(this.formBuilder);

    errorTitle = '';
    errorId = 'AppE';
    errorMessageA = '';
    errorMessageB = '';
    errorMessageC = '';
    errorMessageBClass = '';

    maxRequestedAmount: any = this.authService.getMaxApplicationAmount();

    private uploadedApplication = false;
    private appStartedTime = 0;

    constructor(
        private connectionService: ConnectionService,
        private route: ActivatedRoute,
        private authService: AuthService,
        private formBuilder: FormBuilder,
        public router: Router,
        public googleAnalyticsService: GoogleAnalyticsService
    ) { }

    ngOnInit() {
        this.token = this.route.snapshot.queryParams.token;
        this.googleExperience = this.route.snapshot.queryParams.google_experience;
        this.googleVariant = this.route.snapshot.queryParams.google_variant;
        this.referralPage = this.route.snapshot.queryParams.referral_page;
        this.getStructures().then(
            (data: any) => {
                this.getStates().then(
                    (statesData: any) => {
                        this.getNaics().then(
                            (naicsData: any) => {
                                this.getVendorName();
                            }
                        );
                    }
                );
            }
        );

        setTimeout(function () {
            this.appStartedTime = new Date().getTime();
            this.trackEvent('open');
        }.bind(this), 1000);
    }

    getVendorName() {
        return new Promise((resolve, reject) => {
            if (this.token) {
                this.authService.vendorTokenInfo.then((data) => {
                    if (data && data.dbaName) {
                        this.dbaName = data.dbaName;
                        this.tokenVendorId = data.id;
                        resolve(data);
                    } else {
                        resolve(null);
                    }
                });
            } else {
                this.dbaName = this.authService.vendor.vendorName;
                resolve(null);
            }
        });
    }

    getStructures() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequestUnsecured(`${environment.gateway}utils/structures`, 'application/json').subscribe(
                (data: any) => {
                    this.businessTypes = data.object;
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
    }

    getStates() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequestUnsecured(`${environment.gateway}utils/states`, 'application/json').subscribe(
                (data: any) => {
                    this.statesOfIncorporation = data.object;
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
    }

    getNaics() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequestUnsecured(`${environment.gateway}utils/naics`, 'application/json').subscribe(
                (data: any) => {
                    this.industries = data.object;
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
    }

    getEquipmentSetup() {
        return new Promise((resolve, reject) => {
            this.connectionService.getCustomRequest(`${environment.gateway}posequipmentsetup`, 'application/json').subscribe(
                (data: any) => {
                    this.equipmentSetup = data.object;
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
    }

    showBusinessClicked() {
        this.businessSubmitted = false;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.step = 1;
    }

    showBusinessClickedFS() {
        this.appInfo.form.controls.businessType.setValue('');
        this.businessSubmitted = false;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.step = 1;
    }

    backToOwnersClicked() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.step = 2;
    }

    backToACHClicked() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.step = 3;
    }

    showOwnerClicked(appInfo: ApplicationBusinessInfo) {
        this.appInfo = appInfo;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.step = 2;
    }

    soleContinueClicked() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.step = 5;
    }

    showACHClicked(owners: ApplicationOwnerItem[]) {
        this.owners = owners;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.step = 3;
    }

    showEquipmentClicked(achInfo: ApplicationACHInfo) {
        this.achInfo = achInfo;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.step = 4;
    }

    showCompleteApplicationClicked(appData: any) {
        this.owners = appData.owners;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.trackEvent('application-uploaded', { soleOwner: false });
        this.uploadApplicationAux(false, appData.captcha);
    }

    soleCompleteApplicationClicked(appData: any) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.trackEvent('application-uploaded', { soleOwner: true });
        this.uploadApplicationAux(appData.owner.encode(), appData.captcha);
    }

    uploadApplicationAux(appData: any, captcha: any) {
        this.uploadApplication(appData, captcha).then((data: any) => {
            if (data.msg == 'DATA_ERROR') {
                this.trackEvent('data-error', data);
                this.router.navigateByUrl('/application/data-error-declined', { state: { customerName: this.primaryOwner.getOwnerName(0) } });
            } else if (!data.object) {
                this.trackEvent('offers-decline', data);
                this.router.navigateByUrl('/application/error', { state: { customerName: this.primaryOwner.getOwnerName(0) } });
            } else {
                this.applicationId = data.object.applicationId;
                this.getOffers(data.object.applicationId, false).then((oData: any) => {
                    if (oData.object.vodRequired) {
                        this.trackEvent('finicity-shown');
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                        this.step = 3;
                    } else if (!oData.object || !oData.object.offerList || !oData.object.offerList.length) {
                        this.trackEvent('offers-decline', oData.object);
                        this.router.navigateByUrl('/application/error', { state: { customerName: this.primaryOwner.getOwnerName(0) } });
                    } else {
                        this.trackEvent('offers-shown');
                        this.offers = oData.object;
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                        this.step = 4;
                    }
                }, (oError) => {
                    if (oError && oError.msg == 'DATA_ERROR') {
                        this.trackEvent('data-error', oError);
                        this.router.navigateByUrl('/application/data-error-declined', { state: { customerName: this.primaryOwner.getOwnerName(0) } });
                    } else if (oError.object && (!oError.object.offerList || (oError.object.offerList && oError.object.offerList.length == 0))) {
                        this.trackEvent('offers-decline');
                        this.router.navigateByUrl('/application/declined', { state: { customerName: this.primaryOwner.getOwnerName(0) } });
                    } else {
                        this.trackEvent('error', oError.object ? oError.object : oError);
                        this.router.navigateByUrl('/application/error', { state: { customerName: this.primaryOwner.getOwnerName(0) } });
                    }
                });
            }
        });
    }

    showSummaryClicked() {
        $('#exampleModalCenter').modal();
    }

    getApplicationData(appData: any): any {
        if (appData) {
            appData.salesPersonId = this.token ? this.tokenVendorId : this.authService.getSalesPersonId();
            appData.googleExperience = this.googleExperience ? this.googleExperience : undefined;
            appData.googleVariant = this.googleVariant ? this.googleVariant : undefined;
            return appData;
        } else {
            let data: any = this.appInfo.encode();
            data.lessee.owners = [];
            data.salesPersonId = this.token ? this.tokenVendorId : this.authService.getSalesPersonId();
            this.owners[0].form.controls.email.setValue(data.lessee.email);
            this.owners.forEach(owner => {
                let tOwner = owner.encode();
                data.lessee.owners.push(tOwner);
            });
            data.googleExperience = this.googleExperience ? this.googleExperience : undefined;
            data.googleVariant = this.googleVariant ? this.googleVariant : undefined;
            return data;
        }
    }

    uploadApplication(appData: any, captcha: any) {
        if (this.uploadedApplication) {
            return;
        }

        this.uploadedApplication = true;

        return new Promise((resolve, reject) => {
            this.connectionService.postCustomRequest(
                this.token ? `${environment.gateway}applicationWithCaptcha` : `${environment.gateway}application`,
                this.getApplicationData(appData), 'application/json', this.token ? `captcha=${captcha}` : null, this.token ? 'token' : null, this.token
            ).subscribe(
                (data: any) => {
                    this.trackEvent('opportunity-created');
                    if (this.appStartedTime > 0 && new Date().getTime() - this.appStartedTime - 1000 < 10800000) {
                        this.trackTiming('application-uploaded', new Date().getTime() - this.appStartedTime - 1000);
                    }
                    $('#exampleModalCenter').modal('hide');
                    resolve(data);
                },
                (error: any) => {
                    this.trackEvent('error', error.object ? error.object : error);
                    if (this.appStartedTime > 0 && new Date().getTime() - this.appStartedTime - 1000 < 10800000) {
                        this.trackTiming('application-uploaded', new Date().getTime() - this.appStartedTime - 1000);
                    }
                    this.uploadedApplication = false;
                    this.errorTitle = 'Sorry, we found a problem';
                    this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
                    this.errorMessageB = error.error.msg;
                    this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                    this.errorMessageBClass = 'mB20';
                    $('#exampleModalCenter').modal('hide');
                    $('#errorModalDialogAppE').modal();
                    reject(error.error);
                }
            );
        });
    }

    getOffers(applicationId: number, active?: boolean) {
        return new Promise((resolve, reject) => {
            let url = '';
            if (this.token) {
                url = `${environment.gateway}application/${applicationId}/activeOffersNl`;
            } else if (active) {
                url = `${environment.gateway}application/${applicationId}/activeOffers/${this.authService.getUserId()}`;
            } else {
                url = `${environment.gateway}application/${applicationId}/offers/${this.authService.getUserId()}`;
            }

            this.connectionService.getCustomRequest(url, 'application/json', this.token ? null : `sp_id=${this.authService.getSalesPersonId()}`, this.token ? 'token' : null, this.token).subscribe(
                (data: any) => {
                    if (data.object) {
                        if (data.msg == 'DATA_ERROR') {
                            reject(data);
                        } else if (data.object.status != 'REJECTED') {
                            resolve(data);
                        }
                        else {
                            reject(data);
                        }
                    } else {
                        reject(data);
                    }
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
    }

    get primaryOwner(): ApplicationOwnerItem {
        let primaryOwner = null;
        this.owners.forEach((owner: ApplicationOwnerItem) => {
            if (owner.oForm.authorize.value) {
                primaryOwner = owner;
            }
        });
        return primaryOwner;
    }

    onFinicityCompleted(fData: any) {
        if (fData.object) {
            this.getOffers(this.applicationId, true).then((oData: any) => {
                if (!oData.object || !oData.object.offerList || !oData.object.offerList.length) {
                    this.trackEvent('error', oData.object);
                    this.router.navigateByUrl('/application/error', { state: { customerName: this.primaryOwner.getOwnerName(0) } });
                } else {
                    this.trackEvent('finicity-success');
                    this.trackEvent('offers-shown');
                    this.offers = oData.object;
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    this.step = 4;
                }
            }, (oError) => {
                this.trackEvent('error', oError);
                this.router.navigateByUrl('/application/error', { state: { customerName: this.primaryOwner.getOwnerName(0) } });
            });
        } else {
            this.trackEvent('error', fData.object);
            this.router.navigateByUrl('/application/error', { state: { customerName: this.primaryOwner.getOwnerName(0) } });
        }
    }

    onFinicityErrorCompleted(fError: any) {
        this.trackEvent('error', fError);
        this.router.navigateByUrl('/application/error', { state: { customerName: this.primaryOwner.getOwnerName(0) } });
    }

    trackEvent(event: string, pData?: any) {
        let customDimensions = {};
        customDimensions[environment.GA_DIMENSIONS.REFERRAL_PAGE] = this.referralPage;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_EXPERIENCE] = this.googleExperience ? this.googleExperience : undefined;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_VARIANT] = this.googleVariant ? this.googleVariant : undefined;
        if (pData) { customDimensions[environment.GA_DIMENSIONS.DATA] = JSON.stringify(pData); }
        this.googleAnalyticsService.trackEvent('application', event, this.token ? 'application-token' : 'application', 1, this.token ? customDimensions : null);
    }

    trackTiming(event: string, time: number) {
        let customDimensions = {};
        customDimensions[environment.GA_DIMENSIONS.REFERRAL_PAGE] = this.referralPage;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_EXPERIENCE] = this.googleExperience ? this.googleExperience : undefined;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_VARIANT] = this.googleVariant ? this.googleVariant : undefined;
        this.googleAnalyticsService.trackTiming('application', event, this.token ? 'application-token' : 'application', time, this.token ? customDimensions : null);
    }

    showErrorDialog(error: any) {
        this.errorTitle = 'Sorry, we found a problem';
        this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
        this.errorMessageB = error;
        this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
        this.errorMessageBClass = 'mB20';
        $('#errorModalDialogAppE').modal();
    }

    showFinicityLinkSent() {
        this.errorTitle = 'Email sent';
        this.errorMessageA = 'An email to verify your bank account was sent.';
        this.errorMessageB = '';
        this.errorMessageC = '';
        this.errorMessageBClass = '';
        $('#errorModalDialogAppE').modal();
    }
}
